const AppName = "Whiteclay Kids Zone";
const Language = "Aaniiih";
const Tribe = "Fort Belknap";
const FirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY_FORTBELKNAP,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_FORTBELKNAP,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_FORTBELKNAP,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_FORTBELKNAP,
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_FORTBELKNAP,
  appId: process.env.REACT_APP_FIREBASE_APP_ID_FORTBELKNAP,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_FORTBELKNAP,
};
const FilePath = "https://storage.googleapis.com/fort-belknap-media/";
const NacaApiUrl = process.env.REACT_APP_NACA_API_URL || "https://naca.community";
const NacaCommunityId = "2981a083-5313-4a05-af5d-db6b605c09c2";

const SheetsToPull = [
  { collection: "KZ_AppData", nameToSave: "vocabData" },
  { collection: "KZ_GameDescriptions", nameToSave: "gameDescriptions" },
  { collection: "KZ_GameFilterDataNew", nameToSave: "gameData" },
  { collection: "KZ_PopupWords", nameToSave: "popupWords" },
  { collection: "KZ_uiWords", nameToSave: "uiWords" },
];

const ParamsToFindGame = [
  { data: "category", param: "unit" },
  { data: "target", param: "game-name" },
  { data: "Key", param: "Key" },
];

const NumberDataCategory = "Numbers 1";

const FeedbackLink = "";

const VersionNumber = "2.02.00056";

const Credits = {
  credits: [
    "Website created and designed through Native Teaching Aids LLC by Thomas Koefod and Spencer Kittle",
  ],
  links: [
    {
      link: "https://www.nativeteachingaids.com",
      image: "ntalogo.png",
      style: "short",
    },
  ],
};

const PossibleGames = [
  "Bubble Pop",
  "Counting",
  "Good Guess",
  "Matching",
  "Whack-A-Mole",
  "Word To Image",
  "Verb Activity",
  "Wordless",
];

const config = {
  AppName,
  Language,
  Tribe,
  FirebaseConfig,
  FilePath,
  NacaApiUrl,
  NacaCommunityId,
  SheetsToPull,
  ParamsToFindGame,
  FeedbackLink,
  NumberDataCategory,
  VersionNumber,
  Credits,
  PossibleGames,
};

export default config;

export {
  AppName,
  Language,
  Tribe,
  FirebaseConfig,
  FilePath,
  NacaApiUrl,
  NacaCommunityId,
  SheetsToPull,
  ParamsToFindGame,
  FeedbackLink,
  NumberDataCategory,
  VersionNumber,
  Credits,
  PossibleGames,
};
